import { useEffect, useState, type ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { api } from './api';
import type { Me } from './types';

// Guards a route: unauthenticated readers go to the door with ?next= so they come back here.
export const RequireAuth = ({ admin, children }: { admin?: boolean; children: (me: Me) => ReactNode }) => {
  const [me, setMe] = useState<Me | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    api<Me>('/api/auth/me')
      .then((m) => {
        if (admin && m.role !== 'admin') navigate('/propostas', { replace: true });
        else setMe(m);
      })
      .catch(() => navigate(`/?next=${encodeURIComponent(location.pathname)}`, { replace: true }));
  }, [admin, location.pathname, navigate]);

  if (!me) {
    return (
      <div className="center">
        <div className="spinner" />
      </div>
    );
  }
  return <>{children(me)}</>;
};

export const logout = async (): Promise<void> => {
  await api('/api/auth/logout', { method: 'POST', body: {} }).catch(() => undefined);
  window.location.assign('/');
};

// the door animation plays once, on the first screen after signing in
const DOOR_KEY = 'metron:door';
export const armDoor = (): void => {
  try {
    sessionStorage.setItem(DOOR_KEY, '1');
  } catch {
    /* storage blocked: skip the animation */
  }
};
export const takeDoor = (): boolean => {
  try {
    const on = sessionStorage.getItem(DOOR_KEY) === '1';
    sessionStorage.removeItem(DOOR_KEY);
    return on;
  } catch {
    return false;
  }
};
